import {h} from '@stencil/core';
import {isPlatform} from '@baloise/ds-core';

export const BamJobSearchItem = ({ batch, href, title, subTitle, buttonText }: { batch?: string; href: string; title: string; subTitle: string; buttonText: string }) => {
  return (
    <div class="grid py-medium my-none is-horizontal-line bam-job-search-item">
      {batch && isPlatform('mobile') && (
        <div class="col py-xx-small pb-x-small flex">
          <bal-tag color="purple">{batch}</bal-tag>
        </div>
      )}

      <div class="col tablet:is-7 desktop:is-4 py-xx-small flex flex-grow-2 justify-content-center flex-direction-column">
        <bal-button color="text" href={href} target="_blank" rel="noopener noreferrer" flat>
          {title}
        </bal-button>
        {(isPlatform('mobile') || isPlatform('tablet')) && <bal-text inline>{subTitle}</bal-text>}
      </div>

      {isPlatform('desktop') && (
        <div class="col is-4 py-xx-small pl-xx-large flex align-items-center">
          <bal-text inline>{subTitle}</bal-text>
        </div>
      )}

      {(isPlatform('tablet') || isPlatform('desktop')) && (
        <div class="col py-xx-small flex justify-content-center align-items-center">{batch && <bal-tag color="purple">{batch}</bal-tag>}</div>
      )}

      <div class="col py-xx-small flex justify-content-end align-items-center is-narrow">
        <bal-button expanded={isPlatform('mobile')} color="primary-light" href={href} target="_blank" rel="noopener noreferrer" size="small">
          {buttonText}
        </bal-button>
      </div>
    </div>
  );
};
